import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {useExperiments} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React, {useEffect, useState} from 'react'
import {isMobile} from '../../../../../commons/selectors/environment'
import {useWidgetHost, useWidgetState} from '../../hooks/state-provider'
import {isAnyPageLoaded} from '../../selectors/calendar-layout'
import s from './calendar.scss'
import {MonthlyCalendar} from './monthly'
import {MobileMonthlyCalendar} from './monthly/mobile'

const MIN_WIDTH = 750
const MIN_MOBILE_WIDTH = 280

export const Calendar = () => {
  const {experiments} = useExperiments()
  const [forceMobileLayout, setForceMobileLayout] = useState(false)

  const mobile = useWidgetState(isMobile)
  const loading = !useWidgetState(isAnyPageLoaded)
  const width = useWidgetHost().dimensions.width

  useEffect(() => {
    if (!width) {
      return
    }

    const minWidth = mobile ? MIN_MOBILE_WIDTH : MIN_WIDTH

    if (width < minWidth) {
      setForceMobileLayout(true)
    } else {
      setForceMobileLayout(false)
    }
  }, [width])

  return loading ? null : (
    <div
      data-hook="calendar-layout"
      className={classNames(s.calendar, {
        [s.mobile]: mobile || forceMobileLayout,
        [s.rewire]: experiments.enabled(ExperimentNames.MobileCalendarRewire),
      })}
    >
      {mobile ? <MobileMonthlyCalendar /> : <MonthlyCalendar />}
    </div>
  )
}
